module.exports = "<div md-dialog-title>Borrar Pago</div>\r\n<div md-dialog-content>¿Deseas borrar el pago de la solicitud?</div>\r\n<div md-dialog-actions>\r\n  <button md-button md-raised-button color=\"primary\" md-dialog-close=\"Yes\">Sí</button>\r\n  <button md-button md-raised-button md-dialog-close=\"No\">No</button>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Source/Ecim/Ecim.Web/src/app/components/remove-payment/remove-payment.component.html
// module id = ../../../../../src/app/components/remove-payment/remove-payment.component.html
// module chunks = main